

import Component from 'generic.basecomponent';
import $ from 'jquery';

export default class HeaderTop extends Component {
    constructor(el) {
        super(el);
        this.isActive = false;
        this.init();
    }

    init() {
        this.items = [...this.container.querySelectorAll('.js-header-top-item')];
        this.items.forEach((item) => {
            item.addEventListener('mouseenter', this.hover.bind(this));
        });

        this.container.addEventListener('mouseleave', this.containerBlur.bind(this));

        document.querySelector('.js-header-dropdown').addEventListener('click', this.showStickyNav.bind(this));

        document.addEventListener('click', this.checkOuterClick.bind(this));

        window.addEventListener('scroll', this.scroll.bind(this));

        this.scroll();
    }

    hover() {
        if (!this.isActive) {
            this.isActive = true;
            this.container.classList.add('is-active');
        }
    }

    containerBlur() {
        if (this.isActive) {
            this.isActive = false;
            this.container.classList.remove('is-active');
        }
    }

    scroll() {
        if (window.pageYOffset > 0) {
            document.body.classList.add('sticky-nav');
        } else {
            document.body.classList.remove('sticky-nav');
        }

        if (!document.body.classList.contains('is-blocked')) this.hideStickyNav();
    }

    showStickyNav(e) {
        e.preventDefault();
        document.body.classList.add('sticky-nav--opened');
    }

    hideStickyNav() {
        document.body.classList.remove('sticky-nav--opened');
    }

    checkOuterClick(e) {
        if (document.body.classList.contains('sticky-nav--opened')) {
            const $target = $(e.target);

            if ($target.is('.js-header-dropdown') || $target.parents('.js-header-dropdown').length) return;

            if (!$target.is('.header-top') &&
                !$target.is('.header__nav') &&
                !$target.parents('.header-top').length &&
                !$target.parents('.header__nav').length) {
                this.hideStickyNav();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/header/js/generic.header-top.js